import React from 'react';
import './Header.css';  // Separate CSS file for header styles

function Header() {
  return (
    <div className="header">
      <div className="left">
        <span className="phone-number">+92 302 5388310</span>
      </div>
      <div className="center">
        <img src="/logo.png" alt="Logo" className="logo" />
      </div>
      <div className="right">
        <span className="email">sales@albafoam.pk</span>
      </div>
    </div>
  );
}

export default Header;
